module.exports = __webpack_public_path__ + "static/media/desktop-narrow.fa398f87.webp";